<template>
  <section v-if="slides.length" class="branch-home-func" aria-label="功能性图片">
    <div class="branch-home-func__media" aria-hidden="true">
      <div class="branch-home-func__stack">
        <img
          v-for="(slide, index) in slides"
          :key="slide.src + '-' + index"
          :class="{ 'is-active': index === activeIndex }"
          :src="slide.src"
          alt=""
        >
      </div>
    </div>
    <div v-if="slides.length > 1" class="hero-nav" aria-label="首页轮播" @click.stop>
      <button type="button" class="hero-nav__btn hero-nav__btn--prev" aria-label="上一张" @click="goPrev">
        <span aria-hidden="true">‹</span>
      </button>
      <button type="button" class="hero-nav__btn hero-nav__btn--next" aria-label="下一张" @click="goNext">
        <span aria-hidden="true">›</span>
      </button>
    </div>
  </section>
</template>

<script>
import { BRANCH_HOME_CAROUSEL_INTERVAL } from '../../data/branchHomeHero'

export default {
  name: 'BranchHomeFuncBanner',
  props: {
    slides: {
      type: Array,
      default: () => []
    },
    interval: {
      type: Number,
      default: BRANCH_HOME_CAROUSEL_INTERVAL
    }
  },
  data() {
    return {
      activeIndex: 0,
      timer: null
    }
  },
  computed: {
    current() {
      const list = this.slides || []
      if (!list.length) return null
      return list[this.activeIndex] || list[0]
    }
  },
  watch: {
    slides: {
      immediate: true,
      handler() {
        this.activeIndex = 0
        this.start()
      }
    }
  },
  beforeDestroy() {
    this.clearTimer()
  },
  methods: {
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    start() {
      this.clearTimer()
      if ((this.slides || []).length <= 1) {
        this.activeIndex = 0
        return
      }
      this.timer = setInterval(() => {
        this.activeIndex = (this.activeIndex + 1) % this.slides.length
      }, this.interval || BRANCH_HOME_CAROUSEL_INTERVAL)
    },
    goPrev() {
      const total = (this.slides || []).length
      if (total <= 1) return
      this.activeIndex = (this.activeIndex - 1 + total) % total
      this.start()
    },
    goNext() {
      const total = (this.slides || []).length
      if (total <= 1) return
      this.activeIndex = (this.activeIndex + 1) % total
      this.start()
    }
  }
}
</script>

<style scoped>
.branch-home-func {
  position: relative;
  display: block;
  min-height: 500px;
  overflow: hidden;
  background: var(--primary-deep, #002B49);
}

.branch-home-func__media,
.branch-home-func__stack {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.branch-home-func__stack img {
  display: block;
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  filter: saturate(0.86) contrast(1.02);
  opacity: 0;
  transition: opacity 0.9s ease;
}

.branch-home-func__stack img.is-active {
  opacity: 1;
}
</style>
